<div class="notfound_container notfound_container--top">
  <img src="./assets/images/logoWhite.svg" class="notfound_image" alt="Olleyes logo" />
  <div class="text--center">{{ 'ssoOnboardingMessage' | translate }}</div>
  <br>
  <app-loader [blank]="true"></app-loader>
</div>

